import { PriceListFormTabs, routePaths } from "./constants";
import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { PriceListResource } from "@exonn/js-sdk";

const editRouteObject = {
  path: routePaths.edit.root,
  lazy: () => import("./routes/edit/edit.layout.tsx"),
  children: [
    {
      index: true,
      lazy: () => import("./routes/edit/tabs/general/edit.route.tsx"),
    },
    {
      path: routePaths.edit.tab(PriceListFormTabs.Exceptions).root,
      lazy: () => import("./routes/edit/tabs/exceptions/exceptions.route.tsx"),
      children: [
        {
          index: true,
          lazy: () =>
            import(
              "./routes/edit/tabs/exceptions/tabs/list/list.exceptions.tsx"
            ),
        },
        {
          path: routePaths.edit
            .tab(PriceListFormTabs.Exceptions)
            .tab(":price_list_item_id").root,
          lazy: () =>
            import(
              "./routes/edit/tabs/exceptions/tabs/edit/edit.exception.route.tsx"
            ),
        },
      ],
    },
  ],
};

export const module: Module<PriceListResource> = {
  id: ResourceEnum.PriceList,

  bigIcon: <i className="icon-20-pricelist" />,
  smallIcon: <i className="icon-15-price_lists" />,
  name: (t: TFunction) => t("moduleName.price-lists"),

  edit: {
    routeObject: editRouteObject,
  },

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("tabs.edit.tabs.general.title"),
    },
    exceptions: {
      title: (t) => t("tabs.edit.tabs.exceptions.title"),
    },
  },
};
